import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import HeroAnimation from './HeroAnimation';
import EnhancedDeveloperCard from './EnhancedDeveloperCard';

interface HeroProps {
  title: string;
  subtitle: string;
  buttonText: string;
  buttonLink: string;
  secondaryButtonText?: string;
  secondaryButtonLink?: string;
  backgroundStyle?: 'gradient' | 'pattern' | 'wave';
}





const Hero: React.FC<HeroProps> = ({
  title,
  subtitle,
  buttonText,
  buttonLink,
  secondaryButtonText,
  secondaryButtonLink,
  backgroundStyle = 'gradient'
}) => {
  return (
    <div className={`relative w-full h-screen overflow-hidden ${
      backgroundStyle === 'gradient' 
        ? 'bg-gradient-to-r from-blue-900 via-indigo-800 to-purple-900' 
        : backgroundStyle === 'pattern' 
        ? 'bg-indigo-900 bg-opacity-95' 
        : 'bg-white'
    }`}>
      {/* Background animation */}
      {backgroundStyle === 'gradient' && <HeroAnimation />}
      
      {/* Background patterns */}
      {backgroundStyle === 'pattern' && (
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full">
            <div className="absolute -top-24 -left-24 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl opacity-20"></div>
            <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl opacity-20"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl opacity-20"></div>
          </div>
          <div className="absolute inset-0 bg-grid-white/[0.05] bg-grid-8"></div>
        </div>
      )}
      
      {/* Wave background */}
      {backgroundStyle === 'wave' && (
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-blue-50"></div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full">
              <path fill="#4F46E5" fillOpacity="0.1" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,224C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>
      )}
      
      <div className="container mx-auto px-4 md:px-6 py-24 md:py-32 relative z-10">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-12 md:mb-0 md:pr-12">
          <h1 className="text-inter text-2xl md:text-3xl md:text-4xl font-bold mb-6 text-white md:leading-[1.2]">
              {title}
            </h1>
            <br/>
            <p className={`text-justify md:text-lg text-inter md:text-xl mb-8 max-w-2xl ${
              backgroundStyle === 'wave' ? 'text-white' : 'text-white'
            }`}>
              {subtitle}
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <Link
                to={buttonLink}
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-medium hover:from-blue-700 hover:to-indigo-700 transition duration-300 shadow-lg"
              >
                {buttonText}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              
            </div>
          </div>
          <EnhancedDeveloperCard />
          </div>
      </div>
    </div>
  );
};

export default Hero;